<template>
  <div class="columns is-centered">
    <div class="column">
      <h3 class="title">Billing Information</h3>
      <p class="mb-2">
        We use Stripe to handle all your billing information securely. A pop up
        window will open with your billing information.
      </p>
      <p class="mb-2">
        <small>
          If the pop up window doesn't open automatically, make sure your
          browser allows pop ups from this site. You may also open the portal
          manually by clicking the button below.
        </small>
      </p>
      <div>
        <button class="button is-primary" @click="openBillingPortal">Open Billing Portal</button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BillingPortal',
  props: ['userData'],
  computed: {
    isDelinquent() {
      return this.$route.query.delinquent;
    }
  },
  mounted() {
    this.openBillingPortal();
  },
  beforeDestroy: async function () {
    // Get user data
    this.user = (await this.$axios.get(this.$API.me)).data;
    // Update local storage with user data
    this.$store.commit('auth/setUser', this.user);
    // Trigger an event to notify parent components that the data has been saved successfully.
    this.$emit('updated');
  },
  methods: {
    openBillingPortal() {
      // Call the billing portal API.
      this.$axios.post(this.$API.billingPortal()).then(response => {
        // Redirect to the billing portal.
        window.open(
          response.data.url,
          'Client Billing Portal',
          'width=1000,height=1024'
        );
      });
    }
  }
};
</script>
<style lang="scss" scoped>
figure {
  margin-left: auto;
  margin-right: auto;
}
.tabs {
  margin-top: 15px;
}
.redeem-code {
  margin-bottom: 15px;
}
</style>
